import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-5 py-14 sm:px-6 sm:py-20" data-id="element-122" data-mp="2u5p1aozbyd2q">
      <div className="mx-auto max-w-2xl" data-id="element-123" data-mp="2z2fgzb7836nm">
        <h2 className="text-center font-display text-[1.75rem] font-bold leading-tight text-[#0E3B42] sm:text-[2.4rem]" data-id="element-124" data-mp="2z5bcytzifl9f">
          Domande Frequenti
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-125" data-mp="3rqut9pyyzav9">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.q} className="overflow-hidden rounded-2xl border border-[#0E3B42]/10 bg-[#FBF8F3]" data-id="element-126" data-mp="3d15ntijugkp6" data-mpi={index}>
                <h3 data-id="element-127" data-mp="9lhqrwlmppf4">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-[#F3EDE3]" data-id="element-128" data-mp="9kym3hkzoxj1">
                    <span className="text-[14.5px] font-bold leading-snug text-[#0E3B42] sm:text-base" data-id="element-129" data-mp="2ah1p1y2584ef">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-[#17808D] transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-130" data-mp="25nqeblu7n3h8" />
                  </button>
                </h3>
                {isOpen ? <p className="border-t border-[#0E3B42]/10 px-5 py-4 text-[14.5px] leading-relaxed text-[#3F5F64]" data-id="element-131" data-mp="2ohm7uu82607x">
                    {faq.a}
                  </p> : null}
              </li>;
        })}
        </ul>

        <CTAButton className="mt-9" label="Risolvi i tuoi dubbi con il percorso" subline="Pagamento unico · Accesso a vita" data-id="element-132" data-mp="1jqf929ru9xeo" />
      </div>
    </section>;
}